import log from 'salvo-lite/log'
import Vue from 'vue'
import AjaxCart from '../helpers/AjaxCart'
import Helpers from '../helpers/Helpers'

class SideCart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._vue = null
        log.debug(this.constructor.name, 'Constructed', this)
    }
    async onInit () {
        const _cart = await AjaxCart.getCart()
        this.vue = new Vue({
            el: '.side-cart',
            data: {
                cart: _cart.data
            },
            mounted: function () {
                document.addEventListener('cartItemAdded', e => {
                    this.updateCart()
                    this.$el.classList.remove('closed')
                    document.body.addEventListener('click', e => {
                        if (e.target.classList.contains('side-cart')) {
                            this.hide()
                        }
                    })
                })
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                },
                pluralize: (count, single, multiple) => {
                    if (count > 1) {
                        return '(' + count + ')' + multiple
                    } else {
                        return '(' + count + ')' + single
                    }
                }
            },
            methods: {
                updateCart: async function () {
                    const cart = await AjaxCart.getCart()
                    this.cart = cart.data
                },
                hide: function () {
                    this.$el.classList.add('closed')
                }
            }
        })
        window.vueJob = this.vue
    }
}
export default SideCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SideCart.js